/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/


    window.addEventListener("omnisendForms", function(e) { 
        if (e.detail.type == 'view') {
            document.querySelector('[name="custom_selected_benefit"]').style.display = "none";
            document.querySelector('[name="custom_first_page"]').style.display = "none";
            document.querySelectorAll('button').forEach((button) => {
                button.addEventListener('click', btnAction);
            });
        }
    });



function btnAction(event) {
  const btn = event.target;
  console.info('button:', btn.innerText, btn);
  document.querySelector('[name="custom_selected_benefit"]').value = btn.innerText;
  document.querySelector('[name="custom_first_page"]').value = window.location.href;
  document.querySelectorAll('button').forEach((button) => {
    button.removeEventListener('click', btnAction);
  });

}

// Insert any custom theme js here...
